import SHA256 from 'crypto-js/sha256';

function createSHA256Hash(inputString) {
    return SHA256(inputString).toString();
}

export { createSHA256Hash };